// extracted by mini-css-extract-plugin
export default {"wrapper":"NZx_g","spinner":"gBix0"};